
import React from 'react';
import { message } from 'antd';
import moment from "moment";

import PaginationBase from '../../../common/base/PaginationBase';
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';

import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import usuarioService from '../../../service/seguridad/usuarioService';
import { OTROS, REQUERIMIENTO } from '../../../common/types/tipoComprobanteType';
import { CAJA_CHICA } from '../../../common/types/parametroType';

import Header from './Header';
import Filters from './Filters';
import ResultList from './ResultList';
import ResultListSolicitud from './ResultListSolicitud';
import empresaService from '../../../service/administracion/empresaService';

import FormModal from './FormModal';
import FormModalSolicitud from './FormModalSolicitud';
import FormModalSustento from './FormModalSustento';
import FormModalCompra from './FormModal/FormModalCompra';
import BuscarProductoModal from "./BuscarProductoModal";
import ViewModalSolicitud from './ViewModalSolicitud';
import FormModalOtros from './FormModalOtros/FormModalOtros';
import FormModalDevolucion from './FormModalDevolucion';
import FormModalCierre from './FormModalCierre';
import EditarNombreProductoModal from "./EditarNombreProductoModal";


import ViewModal from './ViewModal';
import ImprimirModal from './ImprimirModal';
import auth from '../../../common/utility/auth';

import proveedorService from "../../../service/administracion/proveedorService";
import almacenService from "../../../service/administracion/almacenService";
import entidadService from '../../../service/administracion/entidadService';

import printFormatMock from "../../../common/mock/printFormatMock";
import monedaService from '../../../service/administracion/monedaService';
import compraService from "../../../service/logistica/compraService";
import documentoNoTributarioService from "../../../service/logistica/documentoNoTributarioService";
import proyectoService from '../../../service/administracion/proyectoService';
import unidadMedidaService from '../../../service/administracion/unidadMedidaService';
import cajaAperturaService from '../../../service/tesoreria/cajaAperturaService';

import tipoComprobanteService from "../../../service/administracion/tipoComprobanteService";
import productoService from "../../../service/administracion/productoService";
import padronReducidoService from "../../../service/integracion/padronReducidoService";

import establecimientoService from '../../../service/administracion/establecimientoService';
import tipoCambioDiarioService from '../../../service/administracion/tipoCambioDiarioService';
import cajaService from '../../../service/administracion/cajaService';
import cajaChicaService from '../../../service/tesoreria/cajaChicaService';
import cajaChicaSolicitudService from '../../../service/tesoreria/cajaChicaSolicitudService';
import centroCostoService from '../../../service/tesoreria/centroCostoService';
import cajaChicaSustentoService from '../../../service/tesoreria/cajaChicaSustentoService';

import empleadoService from '../../../service/administracion/empleadoService';

export const lista_tipo = [{ id: 1, nombre: "SERVICIO" }, { id: 2, nombre: "BIENES" }]

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {

            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingImprimir: false,
            loadingPrint: false,
            loadingVer: false,
            loadingChange: true,
            viewVisible: false,
            viewVisibleSolicitud: false,
            imprimirVisible: false,
            viewCabecera: true,
            visibleSustento: false,
            visibleCompra: false,
            visibleOtros: false,
            visibleDevolucion: false,
            visibleCierre: false,

            searchProductVisible: false,
            editarNombreProductoVisible: false,
            nroCajaChica: '',
            listaEfectivoSoles: [],
            listaEfectivoDolares: [],
            empleados: [],
            cajas: [],
            almacenAll: [],
            estados: [],
            monedas: [],
            proyectos: [],
            proveedores: [],
            entidades: [],
            centroCosto: [],
            establecimientos: [],
            tiposCambioDiario: [],
            tipoAlmacen: [],
            permisosUsuario: [],
            clasificacion: [],
            clasificacionAll: [],
            tiposComprobante: [],
            productos: [],
            unidadesMedida: [],
            empresa: {},
            serie_correlativo: {
                nroSerie: '',
                correlativo: ''
            },
            editarNombreProductoFormValues: {
                id: "",
                nombre: "",
            },
            selected: {},
            searchProductFormValues: {
                nombre: "",
                dataSource: [],
                selectedRowKeys: [],
            },

            imprimirFormValues: {
                file: undefined,
                idComprobante: 0,
                idFormato: 0,
                formatos: printFormatMock.values,
                response: undefined,
            },
            filter: {
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                idEstablecimiento: 0,
                idCaja: 0,
                idEmpleado: 0,// auth.user().flagPermisoTS ? 0 : auth.user().id,
                idEstado: 0,
                idCajaChica: 0,
                nroPlanilla: '',
                cajas: [],
                ...FILTER
            },
            pagination: PAGINATION,
            paginationSolicitud: PAGINATION,

            visible: false,
            visibleSolicitud: false,
            formValues: this.fetchEmptyFormValues(),
            formValuesCompra: this.fetchEmptyFormValuesCompra()

        }
    }


    fetchEmptyFormValues = () => {
        return {
            id: 0,
            serie: "",
            correlativo: "",
            idCajaChicaSolicitud: 0,
            fechaTipoCambio: global.fetchCurrentDateStr(),
            fechaReferencial: global.fetchCurrentDateStr(),
            fechaApertura: global.fetchCurrentDateStr(),
            tipoCambio: 0,
            idEstablecimiento: 0,
            idCaja: 0,
            idMoneda: 0,
            idResponsable: undefined,
            idProyecto: 0,
            idEmpleadoArqueo: 0,
            responsable: '',
            usuario: '',
            montoApertura: 0,
            montoSolicitud: 0,
            montoDisponible: 0,
            montoSustento: 0,
            montoPendiente: 0,
            montoDevuelto: 0,
            montoFinal: 0,
            nroCajaChica: '',
            moneda: '',
            numero: '',
            flagTotal: false,
            centroCosto: [],
            empleados: [],
            cajas: [],
            establecimientos: [],
            monedas: [],
            proyectos: [],
            listaDevolucionDetalle: [],
            listaComprobanteDetalle: [],
            selectedRowKeys: [],
            listaSolicitud: [],

        }
    };

    fetchEmptyFormValuesCompra = () => {
        return {
            id: 0,
            idProveedor: 0,
            IdEstablecimientoProveedor: 0,
            idTipoComprobante: 0,
            idMoneda: SOLES,
            idEstablecimiento: 0,
            idAlmacen: 0,
            idProyecto: 0,
            fechaStr: global.fetchCurrentDateStr(),
            fechaVencimientoStr: global.fetchCurrentDateStr(),
            fechaRecepcionStr: global.fetchCurrentDateStr(),
            fechaDocumentoStr: global.fetchCurrentDateStr(),
            serie: "",
            documento: "",
            idFormaPago: 1,//CONTADO,
            idPendiente: 1,
            idDetraccion: 0,
            idUsuarioRegistro: auth.user().id,
            diasVencimiento: 0,
            tipoCambio: 0,
            observacion: "",
            flagExportacion: false,
            flagPercepcion: false,
            flagDetraccion: false,
            listaCompraDetalle: [],
            listaBanco: [],
            clasificacion: [],
            otroImpuesto: 1,
            idTipoSustento: 0,
            idEntidad: 0,
            idEstablecimientoEntidad: 0,
            /*********************/
            sumaTotalDetalle: 0,
            sumaImporteDescuento: 0,
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaIsc: 0,
            sumaTotal: 0,
            porcentajeDetraccion: 0,
            importeDetraccion: 0,
            totalDetraccion: 0,
            porcentajePercepcion: 0,
            importePercepcion: 0,
            totalPercepcion: 0,
            almacenLoading: false,
            proveedorLoading: false,
            entidadLoading: false,

            activeKey: "1",
            documentoCliente: "",
            monedas: [],
            establecimientos: [],
            almacenes: [],
            proveedores: [],
            direcciones: [],
            tiposComprobante: [],
            tiposComprobanteAll: [],
            detracciones: [],
            detalleProductos: [],
            // conceptos: [],
            proyectos: [],
            empleados: [],
            cuentas: [],
            cajas: [],
            idMotivo: 0,
            idTipo: 2,
            idTipoAlmacen: 0,
            idClasificacion: 1,
            tipo: [],
            tipoAlmacen: [],
            motivos: [],
            entidades: [],
            unidadesMedida: [],
        };
    };


    //#region FILTER

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {

        var filter = { ...this.state.filter, [property]: value };
        if (property === 'idEstablecimiento') {
            filter.cajas = this.state.cajas.filter(m => m.iD_Establecimiento === value && m.idTipoCaja == 2);
            filter.idCaja = 0;
        }
        this.setState({ filter });


    };

    handleClearFilters = () => {
        var filter = {
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            idEstablecimiento: 0,
            idCaja: 0,
            idEmpleado: 0,// auth.user().flagPermisoTS ? 0 : auth.user().id,
            idEstado: 0,
            idCajaChica: 0,
            nroPlanilla: '',
            cajas: [],
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };


    handleFilter = (item) => {
        if (item !== undefined) {
            var formValues = this.fetchEmptyFormValues();
            formValues.establecimientos = this.state.establecimientos ? this.state.establecimientos : [];
            formValues.TipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
            formValues.cajas = this.state.cajas ? this.state.cajas : [];
            formValues.usuario = item[0].nombre;
            formValues.idResponsable = item[0].id;

            formValues.serie = this.state.serie_correlativo.nroSerie;
            formValues.correlativo = this.state.serie_correlativo.correlativo;

            this.setState({ visible: true, formValues });
        }
    };


    //#endregion END  FILTER

    //#region RESULT-LIST
    handleExportExcelView = async () => {
        this.setState({ loadingExcel: true });

        var response = await cajaChicaSolicitudService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Caja Chica Solicitud-" + this.state.nroCajaChica + ".xlsx");

    }
    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = undefined;

        if (this.state.viewCabecera) {
            response = await cajaChicaService.excel(this.state.filter);
            this.setState({ loadingExcel: false });
            if (response !== undefined)
                global.dowloadFile(response.data, "Reporte Caja Apertura.xlsx");
        } else {
            response = await cajaChicaSolicitudService.excel(this.state.filter);
            this.setState({ loadingExcel: false });
            if (response !== undefined)
                global.dowloadFile(response.data, "Reporte de Caja Chica Solicitud-" + this.state.nroCajaChica + ".xlsx");
        }

    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = undefined;
        if (this.state.viewCabecera) {
            response = await cajaChicaService.pdf(this.state.filter);
            this.setState({ loadingPdf: false });
            if (response !== undefined)
                global.dowloadFile(response.data, "Reporte Caja Apertura.pdf");
        } else {
            response = await cajaChicaSolicitudService.pdf(this.state.filter);
            this.setState({ loadingPdf: false });
            if (response !== undefined)
                global.dowloadFile(response.data, "Reporte de Caja Chica Solicitud-" + this.state.nroCajaChica + ".pdf");
        }

    }

    handleImprimir = async (item) => {

        this.setState({ loadingImprimir: true });
        dialog.error('Opción en construcción');
        return false;
    };


    handleChangeImprimir = async (idFormato) => {
        var file = undefined;
        var response = undefined;
        var id = this.state.imprimirFormValues.idComprobante;
        if (idFormato === 1) {
            response = await cajaChicaService.pdfPrint(id);
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await cajaChicaService.pdfTicket(id);
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file,
            },
        });
    };




    handleChangeAutocomplete = (value) => {
        this.setState({
            filter: {
                ...this.state.formValues,
                idResponsable: value.key
            }
        });
    };
    handleClearAutocomplete = () => {
        this.setState({
            filter: {
                ...this.state.filter,
                idResponsable: 0
            }
        });
    }


    handleChangeForm = async (property, value, form) => {
        const listasComprobantes = [];
        if (property === "fechaStr") {
            const fecha = moment(value, "DD/MM/YYYY");
            const fechaVencimiento = moment(
                form.getFieldValue("fechaVencimientoStr"),
                "DD/MM/YYYY"
            );
            const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(
                value
            );

            form.setFieldsValue({
                tipoCambio: this.fetchTipoCambio(DOLARES_AMERICANOS, tiposCambioDiario),
                diasVencimiento: fechaVencimiento.diff(fecha, "days").toString(),
            });
        }


        if (property === "idProveedor") {
            const direcciones = await establecimientoService.listarPorIdEntidad(
                value
            );
            this.setState(
                {
                    formValuesCompra: {
                        ...this.state.formValuesCompra,
                        direcciones: direcciones ? direcciones : [],
                    },
                },
                () => {
                    form.setFieldsValue({
                        idEstablecimientoProveedor: {
                            key: direcciones.length > 0 ? direcciones[0].id : undefined,
                        },
                    });
                }
            );
        }



        if (property === "idEntidad") {
            const direcciones = await establecimientoService.listarPorIdEntidad(
                value
            );
            this.setState(
                {
                    formValuesCompra: {
                        ...this.state.formValuesCompra,
                        direcciones: direcciones ? direcciones : [],
                    },
                },
                () => {
                    form.setFieldsValue({
                        idEstablecimientoEntidad: {
                            key: direcciones.length > 0 ? direcciones[0].id : undefined,
                        },
                    });
                }
            );
        }

        if (property === "direcciones-clear") {
            this.setState({
                formValuesCompra: {
                    ...this.state.formValuesCompra,
                    idProveedor: undefined,
                    idEstablecimientoProveedor: undefined,
                    idEstablecimientoEntidad: undefined,
                    documentoProveedor: "",
                    direcciones: [],
                },
            });
        }

        if (property === "idEstablecimiento") {
            this.setState({
                formValuesCompra: { ...this.state.formValuesCompra, almacenLoading: true },
            });
            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            this.setState({
                formValuesCompra: {
                    ...this.state.formValuesCompra,
                    almacenLoading: false,
                    almacenes: almacenes ? almacenes : [],
                },
                almacenAll: almacenes ? almacenes : []

            });
            form.setFieldsValue({
                idAlmacen: undefined,
                idTipoAlmacen: undefined
            });
        }

        if (property === "idTipoAlmacen") {
            this.setState({ formValuesCompra: { ...this.state.formValuesCompra, almacenLoading: true } });
            const almacenes = this.state.almacenAll.filter(e => e.idTipoAlmacen == value);

            this.setState({
                formValuesCompra: {
                    ...this.state.formValuesCompra,
                    almacenLoading: false,
                    almacenes: almacenes ? almacenes : []
                }
            });

            form.setFieldsValue({
                idAlmacen: undefined
            });
        }

        if (property === "idClasificacion") {

            if (value == 4) {
                this.state.tiposComprobante.forEach(element => {
                    var item = element;
                    if (element.codigoSunat == "01" || element.codigoSunat == "03") {
                        listasComprobantes.push(item);
                    }
                });

                this.setState({
                    formValuesCompra: {
                        ...this.state.formValuesCompra,
                        tiposComprobante: listasComprobantes ? listasComprobantes : []
                    },
                });
            }

            if (value == 5) {
                this.state.tiposComprobante.forEach(element => {
                    var item = element;
                    if (element.codigoSunat == "01" || element.codigoSunat == "03") {
                        listasComprobantes.push(item);
                    }
                });

                this.setState({
                    formValuesCompra: {
                        ...this.state.formValuesCompra,
                        tiposComprobante: listasComprobantes ? listasComprobantes : []
                    },
                });
            }




            form.setFieldsValue({
                idTipoComprobante: undefined,
            });

        }


        if (property === "idTipo") {

            if (this.state.formValuesCompra.listaCompraDetalle.length > 0) {

                dialog.confirm("Al cambiar el Tipo se eliminara el detalle \n ¿Esta seguro de realizar la acción?", () => {
                    this.setState({
                        formValuesCompra: {
                            ...this.state.formValuesCompra,
                            listaCompraDetalle: [],
                            idOrdenCompra: 0,
                            listaCompraReferencia: [],
                            idTipo: value,
                            idTipoComprobante: undefined,
                            clasificacion: this.state.clasificacionAll.filter(item => item.codigo == value)
                        }
                    });

                    form.setFieldsValue({
                        sumaIsc: 0,
                        sumaTotal: 0,
                        sumaSubTotal: 0,
                        sumaIgv: 0,
                        sumaTotalDetalle: 0,
                        idClasificacion: undefined,
                        idTipoComprobante: undefined,
                    });

                }, () => {

                    this.setState({
                        formValuesCompra: {
                            ...this.state.formValuesCompra,
                        }
                    });

                    form.setFieldsValue({
                        idTipo: { key: this.state.formValuesCompra.idTipo },
                    });
                }
                );
            }
            else {


                this.setState({
                    formValuesCompra: {
                        ...this.state.formValuesCompra,
                        listaCompraDetalle: [],
                        idOrdenCompra: 0,
                        idTipoComprobante: 0,
                        listaCompraReferencia: [],
                        listaComprobanteCuota: [],
                    }
                });

                if (value == 1) {
                    this.state.tiposComprobante.forEach(element => {
                        var item = element;
                        if (["01", "03", "14"].includes(element.codigoSunat)) {
                            listasComprobantes.push(item);
                        }
                    });

                }
                if (value == 2) {
                    this.state.tiposComprobante.forEach(element => {
                        var item = element;
                        if (["01", "03", "09"].includes(element.codigoSunat)) {
                            listasComprobantes.push(item);
                        }
                    });
                }
                this.setState({
                    formValuesCompra: {
                        ...this.state.formValuesCompra,
                        tiposComprobante: listasComprobantes ? listasComprobantes : [],
                        clasificacion: this.state.clasificacionAll.filter(item => item.codigo == value),
                        idTipo: value
                    },
                });
                form.setFieldsValue({
                    idClasificacion: undefined,
                    detalleProductos: [],
                    listaCompraReferencia: [],

                });
            }
        }

        if (property === "idTipoComprobante") {

            var data = form.getFieldValue(property);
            if (this.state.formValuesCompra.listaCompraDetalle.length > 0) {
                dialog.confirm(
                    <span>
                        Al cambiar el tipo de comprobante se removera los productos agregados previamente.
                        <br />
                        <span>¿Deseas continuar?'</span>
                    </span>,
                    async () => {
                        this.setState({
                            formValuesCompra: {
                                ...this.state.formValuesCompra,
                                listaCompraDetalle: [],
                                detalleProductos: [],
                                listaComprobanteCuota: [],
                                listaCompraReferencia: [],
                            },
                        });
                        form.setFieldsValue({
                            sumaTotalDetalle: 0,
                            sumaImporteDescuento: 0,
                            sumaSubTotal: 0,
                            sumaIgv: 0,
                            sumaIsc: 0,
                            sumaTotal: 0,
                            porcentajeDetraccion: 0,
                            importeDetraccion: 0,
                            totalDetraccion: 0,
                            porcentajePercepcion: 0,
                            importePercepcion: 0,
                            totalPercepcion: 0,
                            detalleProductos: [],
                            listaCompraDetalle: [],
                        });
                    },
                    () =>
                        form.setFieldsValue({
                            [property]: data,
                        })
                );
            } else {

                this.setState({
                    formValuesCompra: {
                        ...this.state.formValuesCompra,
                        listaComprobanteMetodoPago: [],
                        listaComprobanteCuota: [],
                        idTipoComprobante: value,
                        serie: value == 6 ? "3" : this.state.formValuesCompra.serie,
                        idFormaPago: 1,
                    },
                });

                form.setFieldsValue({
                    idTipoComprobante: { key: value },
                    serie: value == 6 ? "3" : this.state.formValuesCompra.serie,
                    idFormaPago: { key: 1 }
                });
            }
        }
    };
    handleSaveCompra = async (item, form) => {
        item.nroSolicitud = this.state.selected.nroSerie + '-' + this.state.selected.correlativo + '-' + this.state.formValues.numero;

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {

            var response = await compraService.registrar(item);
            var itemDetalle = this.state.formValues.listaComprobanteDetalle;

            if (response.status === 200) {
                form.resetFields();
                itemDetalle.push({
                    identifier: global.fetchUniqueCode(),
                    tipoSustento: 'COMPRAS',
                    idTipoSustento: this.state.formValuesCompra.idTipoSustento,
                    serieCorrelativo: item.serie + '-' + item.documento,
                    serie: item.serie,
                    documento: item.documento,
                    moneda: item.idMoneda == 1 ? 'PEN' : 'USD',
                    idMoneda: item.idMoneda,
                    montoSustento: item.total,
                })

                var montoDevolver = (this.state.formValues.montoSolicitud - (item.total + this.state.formValues.montoSustento));

                this.setState({
                    visibleCompra: false,
                    formValues: {
                        ...this.state.formValues,
                        montoSustento: (item.total + this.state.formValues.montoSustento),
                        montoPendiente: parseFloat(montoDevolver),
                        montoDevuelto: parseFloat(item.total) > this.state.formValues.montoSolicitud && this.state.formValues.montoDisponible ? Math.abs(parseFloat(montoDevolver)) : 0,
                        flagTotal: parseFloat(montoDevolver) > 0 ? true : false,
                        listaComprobanteDetalle: itemDetalle
                    }

                });

                form.setFieldsValue({
                    montoSustento: (item.total + this.state.formValues.montoSustento),
                    montoPendiente: parseFloat(montoDevolver),
                    montoDevuelto: parseFloat(item.total) > this.state.formValues.montoSolicitud && this.state.formValues.montoDisponible ? Math.abs(parseFloat(montoDevolver)) : 0,
                    flagTotal: parseFloat(montoDevolver) > 0 ? true : false,
                    //montoDisponible: this.state.formValues.montoDisponible <= Math.abs(parseFloat(montoDevolver)) ? 0 :
                    //  this.state.formValues.montoDisponible + Math.abs(parseFloat(montoDevolver))

                });
                
                message.success((item.id === 0 ? "Registrado" : "Modificado") + " correctamente.");

                var oreturn = await compraService.aprobar({ id: response.data });

                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map((item) => (<li>{item}</li>))}</ul>);
                return;
            }
            dialog.error("Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.");
        });
    };


    onReturn = () => {
        this.handleClearFilters();

        setTimeout(() => {
            var filter = { ...this.state.filter };
            this._initPagination(filter, cajaChicaService.paginacion);

            this.setState({ viewCabecera: true })
        }, 100);

    };


    handleBuscarEntidad = async (value) => {

        if (value.length > 2) {

            this.setState({ formValuesCompra: { ...this.state.formValuesCompra, entidadLoading: true } });

            const filter = {
                numeroDocumento: value,
                idTipoComprobante: OTROS.ID// FACTURA.ID
            }

            //const response = await padronReducidoService.obtenerPorDocumentoTipoComprobante(filter);
            const response = await entidadService.obtenerTodos(filter);

            if (response === undefined) {
                this.setState({
                    formValuesCompra: {
                        ...this.state.formValuesCompra,
                        entidadLoading: false,
                        entidades: [],
                        direcciones: [],
                    }
                });
            }
            else {

                const resultFilter = response.filter(item => {
                    return (item.numeroDocumento + ' - ' + item.nombre)
                        .toUpperCase()
                        .match(value.toUpperCase());
                });


                var direccionesEstablecimientos = [];
                if (resultFilter.length === 1) {
                    direccionesEstablecimientos = await establecimientoService.listarPorIdEntidad(resultFilter[0].id);
                }

                this.setState({
                    formValuesCompra: {
                        ...this.state.formValuesCompra,
                        entidadLoading: false,
                        entidades: resultFilter,//.entidades,
                        idEntidad: resultFilter.length === 1 ? resultFilter[0].id : 0,
                        direcciones: direccionesEstablecimientos,
                        idEstablecimientoEntidad: direccionesEstablecimientos.length === 1 ? direccionesEstablecimientos[0].id : 0
                    }
                });
            }

        } else {
            this.setState({
                formValuesCompra: {
                    ...this.state.formValuesCompra,
                    entidadLoading: false,
                    entidades: [],
                    direcciones: [],
                }
            });
        }

    };


    handleChangeOtrosForm = async (property, value, form) => {

        if (property === "idEntidad") {
            const direcciones = await establecimientoService.listarPorIdEntidad(
                value
            );
            this.setState(
                {
                    formValuesCompra: {
                        ...this.state.formValuesCompra,
                        direcciones: direcciones ? direcciones : [],
                    },
                },
                () => {
                    form.setFieldsValue({
                        idEstablecimientoEntidad: {
                            key: direcciones.length > 0 ? direcciones[0].id : undefined,
                        },
                    });
                }
            );
        }

        if (property === "direcciones-clear") {
            this.setState({
                formValuesCompra: {
                    ...this.state.formValuesCompra,
                    idProveedor: undefined,
                    idEstablecimientoProveedor: undefined,
                    idEstablecimientoEntidad: undefined,
                    documentoProveedor: "",
                    direcciones: [],
                },
            });
        }

        if (property === "idEstablecimiento") {
            this.setState({
                formValuesCompra: { ...this.state.formValuesCompra, almacenLoading: true },
            });
            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            this.setState({
                formValuesCompra: {
                    ...this.state.formValuesCompra,
                    almacenLoading: false,
                    almacenes: almacenes ? almacenes : [],
                },
                almacenAll: almacenes ? almacenes : []

            });
            form.setFieldsValue({
                idAlmacen: undefined,
                idTipoAlmacen: undefined
            });
        }

        if (property === "idTipoComprobante") {

            if (value == 1) {

                var numeroDocumento = auth.user().numeroDocumento;
                var entidadFilters = this.state.entidades.filter(e => e.numeroDocumento == numeroDocumento);

                const direcciones = entidadFilters.length == 0 ? [] : await establecimientoService.listarPorIdEntidad(entidadFilters[0].id);

                this.setState({
                    formValuesCompra: {
                        ...this.state.formValuesCompra,
                        idTipoComprobante: value,
                        direcciones: direcciones ? direcciones : [],
                        idEntidad: entidadFilters.length > 0 ? entidadFilters[0].id : 0,
                        documentoEntidad: entidadFilters.length > 0 ? entidadFilters[0].numeroDocumento : 0,
                        idEstablecimientoEntidad: direcciones.length > 0 ? direcciones[0].id : undefined,
                    },
                });

                form.setFieldsValue({
                    idTipoComprobante: { key: value },
                    idEntidad: { key: entidadFilters.length > 0 ? entidadFilters[0].id : 0 },
                    documentoEntidad: entidadFilters.length > 0 ? entidadFilters[0].numeroDocumento : 0,
                    idEstablecimientoEntidad: { key: direcciones.length > 0 ? direcciones[0].id : undefined },
                });

            } else {

                this.setState({
                    formValuesCompra: {
                        ...this.state.formValuesCompra,
                        idTipoComprobante: value,
                    },
                });

                form.setFieldsValue({
                    idTipoComprobante: { key: value }
                });
            }
        }
    };

    handleSaveDocumentoNoTributario = async (item, form) => {

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {

            item.nroSolicitud = this.state.selected.nroSerie + '-' + this.state.selected.correlativo + '-' + this.state.formValues.numero;
            var response = await documentoNoTributarioService.registrar(item);
            var itemDetalle = this.state.formValues.listaComprobanteDetalle;

            if (response.status === 200) {
                form.resetFields();
                itemDetalle.push({
                    identifier: global.fetchUniqueCode(),
                    tipoSustento: 'Documento No Tributario',
                    idTipoSustento: this.state.formValuesCompra.idTipoSustento,
                    serieCorrelativo: item.serie + '-' + item.documento,
                    serie: item.serie,
                    documento: item.documento,
                    moneda: item.idMoneda == 1 ? 'PEN' : 'USD',
                    idMoneda: item.idMoneda,
                    montoSustento: item.total,
                })

                var montoDevolver = (this.state.formValues.montoSolicitud - (item.total + this.state.formValues.montoSustento));

                this.setState({
                    visibleOtros: false,
                    formValues: {
                        ...this.state.formValues,
                        montoSustento: (item.total + this.state.formValues.montoSustento),
                        montoPendiente: parseFloat(montoDevolver),
                        montoDevuelto: parseFloat(item.total) > this.state.formValues.montoSolicitud && this.state.formValues.montoDisponible ? Math.abs(parseFloat(montoDevolver)) : 0,
                        flagTotal: parseFloat(montoDevolver) > 0 ? true : false,
                        listaComprobanteDetalle: itemDetalle,
                        //montoDisponible: this.state.formValues.montoDisponible <= Math.abs(parseFloat(montoDevolver)) ? 0 :
                        //  this.state.formValues.montoDisponible + Math.abs(parseFloat(montoDevolver))
                    }

                });

                form.setFieldsValue({
                    montoSustento: (item.total + this.state.formValues.montoSustento),
                    montoPendiente: parseFloat(montoDevolver),
                    montoDevuelto: parseFloat(item.total) > this.state.formValues.montoSolicitud && this.state.formValues.montoDisponible ? Math.abs(parseFloat(montoDevolver)) : 0,
                    flagTotal: parseFloat(montoDevolver) > 0 ? true : false,
                    //montoDisponible: this.state.formValues.montoDisponible <= Math.abs(parseFloat(montoDevolver)) ? 0 :
                    //  this.state.formValues.montoDisponible + Math.abs(parseFloat(montoDevolver))

                });

                message.success((item.id === 0 ? "Registrado" : "Modificado") + " correctamente.");
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map((item) => (<li>{item}</li>))}</ul>);
                return;
            }
            dialog.error("Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.");
        });
    };

    handleBuscarProveedor = async (value, form) => {
        this.setState({
            formValuesCompra: { ...this.state.formValuesCompra, proveedorLoading: true },
        });

        //const response = await padronReducidoService.logistica_proveedor(value);

        var numberDocument = form.getFieldValue("documentoProveedor");
        if (numberDocument == "" || numberDocument == "null" || numberDocument == "undefined") {
            dialog.warning(<ul>Ingrese documento valido</ul>);

            return;
        }

        var response = numberDocument.length == 8 ? await padronReducidoService.obtenerProveedorDniApi(value) :
            await padronReducidoService.obtenerProveedorRucApi(value);
        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
            this.setState({ formValuesCompra: { ...this.state.formValuesCompra, proveedorLoading: false } });

            return;
        }

        if (response.status === 200) {
            this.setState(
                {
                    formValuesCompra: {
                        ...this.state.formValuesCompra,
                        proveedorLoading: false,
                        direcciones: response.data.direcciones,
                    },
                },
                () => {
                    form.setFieldsValue({
                        proveedores: response.data.proveedores,
                        idProveedor:
                            response.data.proveedores.length > 0
                                ? { key: response.data.proveedores[0].id }
                                : undefined,
                        idEstablecimientoProveedor:
                            response.data.direcciones.length > 0
                                ? { key: response.data.direcciones[0].id }
                                : undefined,
                        direccionProveedor:
                            response.data.direcciones.length > 0
                                ? response.data.direcciones[0].direccion
                                : ""
                    });
                }
            );
        } else {
            this.setState(
                {
                    formValuesCompra: {
                        ...this.state.formValuesCompra,
                        proveedorLoading: false,
                        direcciones: [],
                    },
                },
                () => {
                    form.setFieldsValue({
                        proveedores: [],
                        idProveedor: undefined,
                        idEstablecimientoProveedor: undefined,
                    });
                }
            );
        }
    };


    handleChangeProductoModal = (value) => {
        if (value != null && value != undefined && value != '') {
            const dataSource = this.state.productos.filter(item => {
                return (item.codigoReferencia + ' - ' + item.nombre)
                    .toUpperCase()
                    .match(value.toUpperCase());
            });

            this.setState({
                searchProductFormValues: {
                    ...this.state.searchProductFormValues,
                    dataSource: dataSource
                }
            });
        } else {
            this.setState({
                searchProductFormValues: {
                    ...this.state.searchProductFormValues,
                    dataSource: this.state.productos
                }
            });
        }
    };


    handleChangeSolicitudForm = async (property, value, form) => {

        if (property === "idCentroCosto") {
            const empleados = await empleadoService.listarPorCentroCosto({ idCentroCosto: value });
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idResponsable: 0,
                    idCentroCosto: value,
                    empleados: empleados ? empleados : [],
                },
            });

        }
    };


    handleSelectProduct = (selected, rows) => {

        var listaComprobanteDetalle = this.state.formValuesCompra.listaCompraDetalle;
        rows.forEach(row => {
            var filter = this.state.formValuesCompra.listaCompraDetalle.filter(m => { return m.idProducto === row.id; });
            if (filter.length === 0) {

                var item = {
                    identifier: global.fetchUniqueCode(),
                    idProducto: row.id,
                    idTipoProducto: row.idTipoProducto,
                    codigo: row.codigoReferencia,
                    codigoBarra: row.codigoBarra,
                    nombre: row.nombre,
                    nombreUnidadMedida: row.nombreUnidadMedida,
                    flagAfecto: row.flagIGVAfecto,
                    flagGratuito: row.flagGratuito,
                    flagISC: row.flagISC,
                    flagExonerado: row.flagExonerado,
                    isc: 0,
                    flagVencimiento: row.flagVencimiento,
                    fechaVencimientoStr: row.flagVencimiento ? global.fetchCurrentDateStr() : null,
                    fechaProduccionStr: global.fetchCurrentDateStr(),
                    precioUnitario: 0,
                    valorUnitario: 0,
                    precioUnitarioSinIGV: 0,
                    cantidad: 0,
                    totalDetalle: 0,
                    numeroLote: '',
                    porcentajeDescuento: 0,
                    importeDescuento: 0,
                    subTotal: 0,
                    igv: 0,
                    total: 0,
                };
                listaComprobanteDetalle.push(item)
            }
        });

        listaComprobanteDetalle = listaComprobanteDetalle.filter(m => selected.filter(f => f === m.idProducto).length);

        this.setState({
            formValuesCompra: {
                ...this.state.formValuesCompra,
                listaCompraDetalle: listaComprobanteDetalle
            },
            searchProductFormValues: {
                ...this.state.searchProductFormValues,
                selectedRowKeys: selected
            }
        });


    };

    handleEditarNombreProducto = (row, onSetFieldsValue, onGetFieldValue) => {
        var formValues = {
            id: row.identifier,
            nombre: onGetFieldValue(`arrNombre[${row.identifier}]`),
        };

        this.setState({
            editarNombreProductoVisible: true,
            editarNombreProductoFormValues: formValues,
            onSetFieldsValue,
            onGetFieldValue,
        });
    };

    handleSaveEditarNombreProducto = (values, form) => {
        form.resetFields();
        this.setState({ editarNombreProductoVisible: false });
        var detalleProductos = this.state.onGetFieldValue("detalleProductos");
        detalleProductos.forEach((item) => {
            if (item.identifier === values.id) {
                item.nombre = values.nombre;
                return;
            }
        });

        this.state.onSetFieldsValue({
            detalleProductos,
            [`arrNombre[${values.id}]`]: values.nombre,
        });
    };

    //#endregion END  RESULT-LIST



    //#region REGISTRO NUEVO
    handleNew = async () => {
        var numeroDocumento = auth.user().numeroDocumento;
        var params = auth.user().parametros;
        var paramCaja = params.filter((m) => m.abreviatura === CAJA_CHICA)[0].valor === "1" ? true : false;

        if (!paramCaja) {
            dialog.error("Este modulo no esta habilitado para este PLAN");
            return false;
        }

        const seriecorrelativo = await cajaChicaService.Getcorrelativo();
        var formValues = this.fetchEmptyFormValues();
        formValues.establecimientos = this.state.establecimientos;

        formValues.proyectos = this.state.proyectos;
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.cajas = this.state.cajas ? this.state.cajas : [];
        formValues.monedas = this.state.monedas;
        formValues.centroCosto = this.state.centroCosto;
        formValues.nroCajaChica = this.state.nroCajaChica;

        formValues.serie = seriecorrelativo.nroSerie;

        formValues.correlativo = seriecorrelativo.correlativo;

        formValues.listaEfectivoSoles = this.state.listaEfectivoSoles;
        formValues.listaEfectivoDolares = this.state.listaEfectivoDolares;

        if (this.state.viewCabecera) {

            var entidadFilters = this.state.empleados.filter(e => e.numeroDocumento == numeroDocumento);
            formValues.idResponsable = entidadFilters.length == 0 ? 0 : entidadFilters[0].id;
            formValues.empleados = this.state.empleados;

            this.setState({ visible: true, formValues });
        } else {

            if (this.state.selected.montoSaldo == 0) {
                dialog.error("no se puede realizar la solicitud ya que en la caja no hay saldo suficiente ");
                return false;
            }
            formValues.empleados = [];

            formValues.montoDisponible = this.state.selected.montoSaldo;
            formValues.moneda = this.state.selected.moneda;
            formValues.idMoneda = this.state.selected.idMoneda;

            this.setState({ visibleSolicitud: true, formValues });

        }


    };


    fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
        const filter = (tiposCambioDiario ? tiposCambioDiario : this.state.tiposCambioDiario).filter(m => m.idMoneda === idMoneda);
        if (filter.length > 0)
            return parseFloat(filter[0].venta).toFixed(3);
        else
            return '0.000';
    };

    handleChangeEstablecimiento = (values, form) => {
        const filter = this.state.cajas.filter(m => m.iD_Establecimiento === values && m.idTipoCaja == 2);
        if (filter.length == 0)
            message.info("no se encuentra la caja registrada! ");

        this.setState({
            formValues: {
                ...this.state.formValues,
                cajas: filter,
                idCaja: filter.length > 0 ? filter[0].id : 0
            },
            loadingChange: false,
        });

    };

    handleNewDevolucion = async () => {

        if (this.state.selected.montoSaldo == 0) {
            dialog.error("no se puede realizar la solicitud ya que en la caja no hay saldo suficiente ");
            return false;
        }

        var formValues = this.fetchEmptyFormValues();
        formValues.establecimientos = this.state.establecimientos;

        formValues.proyectos = this.state.proyectos;
        formValues.empleados = this.state.empleados;
        formValues.montoDisponible = this.state.selected.montoSaldo;
        formValues.moneda = this.state.selected.moneda;
        formValues.idMoneda = this.state.selected.idMoneda;
        formValues.idEstablecimiento = this.state.selected.idEstablecimiento;
        formValues.idCaja = this.state.selected.id;

        this.setState({ visibleDevolucion: true, formValues });


    };
    handleSearch = async () => {

        var response = undefined;

        if (this.state.viewCabecera) {
            response = await cajaChicaService.paginacion({ ...this.state.filter });
            this.setState({
                pagination: response
            })
            return false;
        }

        else {
            response = await cajaChicaSolicitudService.paginacion({ ...this.state.filter });
            this.setState({
                paginationSolicitud: response ? response : [],
            });
            return false;
        }
    }


    handleSave = async (values, form) => {

        dialog.confirm(values.id === 0 ? "¿Desea apertura la caja " + values.serie + "-" + values.correlativo + "?" : "¿Esta seguro de realizar la acción?", async () => {
            var response;

            if (values.id === 0)
                response = await cajaChicaService.registrar(values);

            else
                response = await cajaChicaService.modificar(values);

            if (response.status === 200) {

                form.resetFields();
                this.setState({
                    visible: false,
                });

                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    handleEdit = async (item) => {


        if (item.hasSolicitud) {
            dialog.error('La caja chica cuenta con solicitud! ');
            return false;
        }

        var response = await cajaChicaService.obtenerPorId(item.id);

        var usuarioId = auth.user().id;
        var usuario = auth.user().nombre + ' ' + auth.user().apellidoMaterno + ' ' + auth.user().apellidoPaterno;

        if (response !== undefined) {


            var formValues = this.fetchEmptyFormValues();
            formValues.establecimientos = this.state.establecimientos ? this.state.establecimientos : [];
            formValues.tipoCambio = response.tipoCambio;
            formValues.fechaTipoCambio = response.fecha;
            formValues.cajas = this.state.cajas ? this.state.cajas : [];
            formValues.monedas = this.state.monedas ? this.state.monedas : [];
            formValues.proyectos = this.state.proyectos ? this.state.proyectos : [];

            formValues.serie = response.serie;
            formValues.idEstablecimiento = response.idEstablecimiento;
            formValues.idCaja = response.idCaja;
            formValues.idMoneda = response.idMoneda;
            formValues.idResponsable = usuarioId;
            formValues.idProyecto = response.idProyecto;

            formValues.montoApertura = response.montoApertura;
            formValues.empleados = [{ 'id': usuarioId, 'nombre': usuario }];

            formValues.id = item.id;

            formValues.correlativo = response.correlativo;

            this.setState({ visible: true, formValues });


        }
    }


    handleArqueo = async (item) => {

        var response = await cajaChicaService.obtenerPorId(item.id);

        if (response !== undefined) {

            if (response.hasSolicitud) {
                dialog.error('Hay solicitudes Pendientes por Cerrar!');
                return false;
            }
            var formValues = this.fetchEmptyFormValues();
            formValues.establecimientos = this.state.establecimientos ? this.state.establecimientos : [];
            formValues.tipoCambio = response.tipoCambio;
            formValues.fechaTipoCambio = response.fecha;
            formValues.cajas = this.state.cajas ? this.state.cajas : [];
            formValues.monedas = this.state.monedas ? this.state.monedas : [];
            formValues.proyectos = this.state.proyectos ? this.state.proyectos : [];

            formValues.serie = response.serie;
            formValues.idEstablecimiento = response.idEstablecimiento;
            formValues.idCaja = response.idCaja;
            formValues.idMoneda = response.idMoneda;
            formValues.idResponsable = response.idEmpleado;
            formValues.montoApertura = response.montoApertura;
            formValues.empleados = this.state.empleados;// [{ 'id': usuarioId, 'nombre': usuario }];
            formValues.idProyecto = response.idProyecto;
            formValues.montoSaldo = response.montoSaldo;

            formValues.id = item.id;

            formValues.correlativo = response.correlativo;

            formValues.listaEfectivoSoles = this.state.listaEfectivoSoles;
            formValues.listaEfectivoDolares = this.state.listaEfectivoDolares;

            this.setState({ visibleCierre: true, formValues });


        }
    }

    handleSaveArqueo = async (values, form) => {

        dialog.confirm(values.id === 0 ? "¿Desea Arquear la caja " + values.serie + "-" + values.correlativo + "?" : "¿Esta seguro de realizar la acción?", async () => {


            var response = await cajaChicaService.arquearCaja(values);

            if (response.status === 200) {

                form.resetFields();
                this.setState({
                    visibleCierre: false,
                });

                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    handleSaveSolicitud = async (item, form) => {

        var montoMaximoSolicitud = parseFloat(this.state.empresa.porcentajeCajaChica);

        if (montoMaximoSolicitud > 0) {
            var porcentaje = parseFloat((montoMaximoSolicitud * 100) / 100);

            if (item.montoSolicitud >= parseFloat(porcentaje)) {
                dialog.confirm("El monto total de la solicitud excede el monto máximo establecido " + porcentaje + "% ¿Desea continuar?", async () => {
                    this.handleSaveSolicitudUpdate(item, form);
                }, async () => {
                    this.setState({ saveLoading: false });
                });
            }
            else {
                this.handleSaveSolicitudUpdate(item, form);
            }
        } else {
            this.handleSaveSolicitudUpdate(item, form);
        }

    };


    handleSaveSolicitudUpdate = async (values, form) => {
        values.idCajaChica = this.state.selected.id;
        dialog.confirm(values.id === 0 ? "¿Desea generar la solicitud  ?" : "¿Esta seguro de realizar la acción?", async () => {
            var response;

            if (values.id === 0)
                response = await cajaChicaSolicitudService.registrar(values);

            else
                response = await cajaChicaSolicitudService.modificar(values);

            if (response.status === 200) {

                var responseSaldo = await cajaChicaSolicitudService.GetSaldoCajaChicaPorId({ id: this.state.selected.id });

                // montoSaldo: (this.state.selected.montoSaldo - values.montoSolicitud)

                form.resetFields();
                this.setState({
                    visibleSolicitud: false,
                    selected: {
                        ...this.state.selected,
                        montoSaldo: responseSaldo.montoSaldo
                    }
                });

                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this.handleSearch(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleSaveSustento = async (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            if (values.id === 0)
                response = await cajaChicaSustentoService.registrar(values);

            else
                response = await cajaChicaSustentoService.modificar(values);

            if (response.status === 200) {

                var responseSaldo = await cajaChicaSolicitudService.GetSaldoCajaChicaPorId({ id: this.state.selected.id });

                form.resetFields();
                this.setState({
                    visibleSustento: false,
                    selected: {
                        ...this.state.selected,
                        montoSaldo: responseSaldo.montoSaldo
                    }
                });

                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this.handleSearch(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleViewSustento = async (item) => {
        var formValues = this.fetchEmptyFormValues();
        formValues.serie = this.state.selected.nroSerie;
        formValues.correlativo = this.state.selected.correlativo;
        formValues.moneda = item.moneda;
        formValues.montoSolicitud = item.montoSolicitud;
        formValues.numero = item.numero;
        formValues.idCajaChicaSolicitud = item.id;
        formValues.idMoneda = item.idMoneda;

        formValues.montoDisponible = this.state.selected.montoSaldo;

        this.setState({ visibleSustento: true, formValues });
    }

    handleAddDetalle = async (value) => {
        if (value == 1) {
            var formValuesCompra = this.fetchEmptyFormValuesCompra();
            formValuesCompra.monedas = this.state.monedas;
            formValuesCompra.proveedores = this.state.proveedores;
            formValuesCompra.establecimientos = this.state.establecimientos;
            formValuesCompra.tipoAlmacen = this.state.tipoAlmacen;
            formValuesCompra.tipo = lista_tipo;
            formValuesCompra.clasificacion = this.state.clasificacion;
            formValuesCompra.tiposComprobante = this.state.tiposComprobante;
            formValuesCompra.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
            formValuesCompra.idTipoSustento = value;
            formValuesCompra.idMoneda = this.state.formValues.idMoneda;

            this.setState({ visibleCompra: true, formValuesCompra });
            return false;
        }

        if (value == 2) {
            dialog.error('Este modulo en proceso de desarrollo !');
            return false;
        }

        if (value == 3) {
            var listasComprobantes = [];
            this.state.tiposComprobante.forEach(element => {
                var item = element;
                if (["Otros", "Nota de Venta"].includes(element.nombre)) {
                    listasComprobantes.push(item);
                }
            });

            var numeroDocumento = auth.user().numeroDocumento;
            var entidadFilters = this.state.entidades.filter(e => e.numeroDocumento == numeroDocumento);

            const direcciones = entidadFilters.length == 0 ? [] : await establecimientoService.listarPorIdEntidad(entidadFilters[0].id);

            var formValuesCompra = this.fetchEmptyFormValuesCompra();
            formValuesCompra.monedas = this.state.monedas;
            formValuesCompra.entidades = this.state.entidades;
            formValuesCompra.establecimientos = this.state.establecimientos;
            formValuesCompra.tiposComprobante = listasComprobantes;
            formValuesCompra.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
            formValuesCompra.idTipoSustento = value;
            formValuesCompra.idTipo = 1;
            formValuesCompra.idEntidad = entidadFilters.length > 0 ? entidadFilters[0].id : 0;
            formValuesCompra.documentoEntidad = entidadFilters.length > 0 ? entidadFilters[0].numeroDocumento : 0;
            formValuesCompra.direcciones = direcciones ? direcciones : [];
            formValuesCompra.idEstablecimientoEntidad = direcciones.length > 0 ? direcciones[0].id : undefined;
            formValuesCompra.idEstablecimiento = this.state.selected.idEstablecimiento
            formValuesCompra.idMoneda = this.state.formValues.idMoneda;

            formValuesCompra.idTipoComprobante = 1; // otros
            formValuesCompra.unidadesMedida = this.state.unidadesMedida;
            formValuesCompra.idTipoComprobante = listasComprobantes.length > 0 ? listasComprobantes[0].id : 0;
            this.setState({ visibleOtros: true, formValuesCompra });
            return false;
        }

    }


    handleAgregarItem = (onSetFieldsValue, onGetFieldValue) => {

        var listaComprobanteDetalle = this.state.formValuesCompra.listaCompraDetalle;

        var item = {
            identifier: global.fetchUniqueCode(),
            idProducto: 1,
            idTipoProducto: 2, //Servicio
            codigo: null,
            nombre: 'Item ' + this.state.formValuesCompra.listaCompraDetalle.length,
            nombreUnidadMedida: 'UNIDAD (SERVICIOS)',
            idUnidadMedida: 58, //bienes
            flagAfecto: true,
            flagGratuito: false,
            flagISC: false,
            flagExonerado: false,
            isc: 0,
            precioUnitario: 0,
            valorUnitario: 0,
            precioUnitarioSinIGV: 0,
            cantidad: 0,
            totalDetalle: 0,
            numeroLote: '',
            porcentajeDescuento: 0,
            importeDescuento: 0,
            subTotal: 0,
            igv: 0,
            total: 0,
        };
        listaComprobanteDetalle.push(item);


        this.setState({
            formValues: {
                ...this.state.formValues,
                listaCompraDetalle: listaComprobanteDetalle
            },
        });


    };

    handleAgregarDetalle = (onSetFieldsValue, onGetFieldValue) => {
        this.setState(
            {
                onSetFieldsValue,
                onGetFieldValue,
            },
            () => {

                this.handleOpenSearchProductModal();
            }
        );
    };
    handleOpenSearchProductModal = async () => {

        var tipoActividad = this.state.formValuesCompra.idTipo;

        var productos = await productoService.listar();
        var productos_filter = tipoActividad == 1 ? productos.filter(m => m.idTipoProducto != 1) : productos.filter(m => m.idTipoProducto === 1);
        this.setState({
            searchProductVisible: true,
            searchProductFormValues: {
                ...this.state.searchProductFormValues,
                dataSource: productos_filter,
                selectedRowKeys: this.state.formValuesCompra.listaCompraDetalle.map(function (v) {
                    return v.idProducto;
                })
            },
            productos
        });
    };

    handleRemoverProducto = (row, form) => {
        this.setState({
            formValuesCompra: {
                ...this.state.formValuesCompra,
                listaCompraDetalle: this.state.formValuesCompra.listaCompraDetalle.filter(
                    (m) => m.identifier !== row.identifier
                ),
            },
        },
            () => {
                var detalleProductos = form.getFieldValue("detalleProductos");
                form.setFieldsValue({
                    detalleProductos: detalleProductos.filter(
                        (m) => m.identifier !== row.identifier
                    ),
                });
            }
        );
    };
    //#endregion END  REGISTRO NUEVO

    //#region VIEW


    handleView = async (item) => {


        var response = await cajaChicaService.obtenerPorId(item.id);

        if (response !== undefined) {

            var formValues = this.fetchEmptyFormValues();
            formValues.establecimientos = this.state.establecimientos ? this.state.establecimientos : [];
            formValues.monedas = this.state.monedas ? this.state.monedas : [];
            formValues.tipoCambio = response.tipoCambio;
            formValues.fechaTipoCambio = response.fecha;
            formValues.cajas = this.state.cajas ? this.state.cajas : [];
            formValues.empleados = this.state.empleados ? this.state.empleados : [];
            formValues.serie = response.serie;
            formValues.idEstablecimiento = response.idEstablecimiento;
            formValues.idResponsable = response.idEmpleado;
            formValues.idCaja = response.idCaja;
            formValues.responsable = response.empleadoCaja;
            formValues.usuario = response.nroEmpleado;
            formValues.idMoneda = response.idMoneda;
            formValues.listaSolicitud = response.detalles;
            formValues.idCajaChica = item.id;

            formValues.montoApertura = response.montoApertura;
            formValues.correlativo = response.correlativo;

            this.setState({
                viewVisible: true,
                formValues,
                selected: item,
                filter: {
                    ...this.state.filter,
                    idCajaChica: item.id
                },
                nroCajaChica: item.serieCorrelativo,

            });


        }
    }


    handleBuscarDocumentoSustento = async (item) => {

        var nroSolicitud = this.state.selected.nroSerie + '-' + this.state.selected.correlativo + '-' + this.state.formValues.numero;

        var response = await cajaChicaSustentoService.listaDocumentoSustento({ nroSolicitud: nroSolicitud });

        if (response !== undefined && response.length > 0) {

            var montoSustento = parseFloat(response.reduce((a, b) => a + (b["montoSustento"] || 0), 0));

            var montoDevolver = (this.state.formValues.montoSolicitud - montoSustento);

            this.setState({
                visibleOtros: false,
                formValues: {
                    ...this.state.formValues,
                    montoSustento: montoSustento,
                    montoPendiente: parseFloat(montoDevolver),
                    montoDevuelto: parseFloat(montoSustento) > this.state.formValues.montoSolicitud && this.state.formValues.montoDisponible ? Math.abs(parseFloat(montoDevolver)) : 0,
                    flagTotal: parseFloat(montoDevolver) > 0 ? true : false,
                    listaComprobanteDetalle: response,
                }

            });
        } else {

            dialog.error('No hay documentos registrados para este solicitud!');
        }
    }


    handleCerrar = (values) => {
        dialog.confirm("Desea cerrar la caja chica " + values.serieCorrelativo + "?", async () => {
            var response;

            response = await cajaChicaService.cerrar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this.handleSearch(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    handleAnular = (values) => {

        dialog.confirm("Desea anular la caja chica " + values.serieCorrelativo + "?", async () => {
            var response;

            response = await cajaChicaService.anular(values);
            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this.handleSearch(this.state.filter);
                return;
            }
            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleDownloadPdf = async () => {

        global.downloadFileBlob(this.state.imprimirFormValues.file, this.state.selectedItem.nroSerie_correlativo + ".pdf");
    };


    handleViewSolicitud = async (item) => {
        var response = await cajaChicaSolicitudService.obtenerPorId(item.id);

        if (response !== undefined) {

            var formValues = this.fetchEmptyFormValues();
            formValues.monedas = this.state.monedas ? this.state.monedas : [];
            formValues.centroCosto = this.state.centroCosto ? this.state.centroCosto : [];
            formValues.fechaApertura = response.fechaSolicitud;
            formValues.empleados = this.state.empleados ? this.state.empleados : [];
            formValues.idResponsable = response.idEmpleado;
            formValues.idMoneda = response.idMoneda;
            formValues.idCentroCosto = response.idCentroCosto;
            formValues.moneda = response.moneda;

            formValues.montoSolicitud = response.montoSolicitud;
            formValues.motivo = response.motivo;
            formValues.listaComprobanteDetalle = response.detalles;
            this.setState({ viewVisibleSolicitud: true, formValues });


        }
    }


    handleSaveDevolucion = async (values, form) => {


        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {

            var response = await cajaChicaService.devolver(values);
            if (response.status === 200) {

                var responseSaldo = await cajaChicaSolicitudService.GetSaldoCajaChicaPorId({ id: this.state.selected.id });

                form.resetFields();
                this.setState({
                    visibleDevolucion: false,
                    selected: {
                        ...this.state.selected,
                        montoSaldo: responseSaldo.montoSaldo
                    }
                });

                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this.handleSearch(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    handleSolicitud = async (item) => {
        var filter = this.state.filter;
        filter.idCajaChica = item.id;
        var response = await cajaChicaSolicitudService.paginacion(filter);
console.log(item)
        this.setState({
            viewCabecera: false,
            selected: item,
            nroCajaChica: item.serieCorrelativo,
            filter: {
                ...this.state.filter,
                idCajaChica: item.id
            }
        });

        if (response !== undefined) {
            this.setState({ paginationSolicitud: response });

        }
    }

    handleAprobarSolicitud = (values) => {
        dialog.confirm("Desea Aprobar la solicitud " + values.numero + "?", async () => {
            var response;

            response = await cajaChicaSolicitudService.aprobar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this.handleSearch(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleAnularSolicitud = (values) => {

        dialog.confirm("Desea anular la solicitud " + values.numero + "?", async () => {
            var response;

            response = await cajaChicaSolicitudService.anular(values);
            if (response.status === 200) {

                var responseSaldo = await cajaChicaSolicitudService.GetSaldoCajaChicaPorId({ id: this.state.selected.id });
                this.setState({
                    selected: {
                        ...this.state.selected,
                        montoSaldo: responseSaldo.montoSaldo
                    }
                });

                message.success('Proceso realizado correctamente.');
                this.handleSearch(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleOpenSearchSolicitud = async (idResponsable) => {

        var filter = new Object();
        filter.idEmpleado = idResponsable;
        filter.idCajaChica = this.state.selected.id;

        var solicitudes = await cajaChicaSolicitudService.obtenerPorIdEmpleado(filter);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaDevolucionDetalle: solicitudes
            }
        });
    };

    handleSelectSolicitud = (row, item) => {
        debugger
        if (row.length == 0) {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    selectedRowKeys: [],
                }
            });
            return true;
        }

        this.setState({
            formValues: {
                ...this.state.formValues,
                selectedRowKeys: row
            }
        });

    };
    //#endregion END VIEW




    //#region LOAD  SERVICE OR CALL SERVICE

    async componentDidMount() {

        this._initPagination(this.state.filter, cajaChicaService.paginacion);

        const proveedores = await proveedorService.listar();
        const empresa = await empresaService.obtenerPrincipal(0);

        const establecimientos = await establecimientoService.principales();
        const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(global.fetchCurrentDateStr());
        const cajas = await cajaService.listar();
        const monedas = await monedaService.listar();
        const centroCosto = await centroCostoService.listar();
        const empleados = await empleadoService.listar();
        const tipoAlmacen = await almacenService.listaTipoEstablecimiento('000001');
        const clasificacion = await compraService.listarClasificacion();
        var clasificacion_filter = clasificacion.filter(m => m.codigo === 2);
        const proyectos = await proyectoService.listar();
        const unidadesMedida = await unidadMedidaService.listar();

        const filterEntidad = {
            numeroDocumento: null,
            idTipoComprobante: OTROS.ID// FACTURA.ID
        }
        const entidades = await entidadService.obtenerTodos(filterEntidad);

        const tiposComprobante = await tipoComprobanteService.listar();

        //const empleados = await vendedorService.listar();
        const seriecorrelativo = await cajaChicaService.Getcorrelativo();
        const permisosUsuario = await usuarioService.usarioEstablecimiento(auth.user().id, 1)
        const efectivos = await cajaAperturaService.Getefectivo();

        const soles = efectivos.filter(m => m.id_Moneda === SOLES);
        const dolares = efectivos.filter(m => m.id_Moneda === DOLARES_AMERICANOS);

        const estado = await cajaService.listarEstado();
        this.setState({
            loadingSource: false,
            empresa: empresa ? empresa : {},
            establecimientos: establecimientos ? establecimientos : [],
            cajas: cajas ? cajas : [],
            estados: estado ? estado : [],
            monedas: monedas ? monedas : [],
            proveedores: proveedores ? proveedores : [],
            centroCosto: centroCosto ? centroCosto : [],
            serie_correlativo: seriecorrelativo ? seriecorrelativo : {},
            tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
            empleados: empleados ? empleados : [],
            tipoAlmacen: tipoAlmacen ? tipoAlmacen : [],
            clasificacion: clasificacion_filter ? clasificacion_filter : [],
            clasificacionAll: clasificacion ? clasificacion : [],
            proyectos: proyectos ? proyectos : [],
            permisosUsuario: permisosUsuario ? permisosUsuario : [],
            tiposComprobante: tiposComprobante ? tiposComprobante : [],
            entidades: entidades ? entidades : [],
            unidadesMedida: unidadesMedida ? unidadesMedida : [],
            listaEfectivoSoles: soles ? soles : [],
            listaEfectivoDolares: dolares ? dolares : [],
        });

    }

    //#endregion END  LOAD  SERVICE OR CALL SERVICE


    render() {
        return (
            <div>
                <Header
                    title={this.state.viewCabecera ? "Caja Chica" : " Solicitud de Efectivo " + this.state.nroCajaChica}
                    onNew={this.handleNew}
                    onReturn={this.onReturn}
                    onDevolucion={this.handleNewDevolucion}
                    loadingNew={this.state.loadingSource}
                    onSearch={this.handleSearch}
                    onClearFilters={this.handleClearFilters}
                    viewCabecera={this.state.viewCabecera}
                />

                <Filters
                    filter={this.state.filter}
                    establecimientos={this.state.establecimientos}
                    cajas={this.state.cajas}
                    empleados={this.state.empleados}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                {this.state.viewCabecera ?
                    <ResultList
                        pagination={this.state.pagination}
                        loadingEdit={this.state.loadingSource}
                        loadingExcel={this.state.loadingExcel}
                        loadingPdf={this.state.loadingPdf}
                        loadingPrint={this.state.loadingPrint}
                        loadingImprimir={this.state.loadingImprimir}
                        onExportExcel={this.handleExportExcel}
                        onExportPdf={this.handleExportPdf}
                        onPrint={this.handlePrint}
                        onArqueo={this.handleArqueo}
                        onView={this.handleView}
                        onEdit={this.handleEdit}
                        onSolicitud={this.handleSolicitud}
                        onAnular={this.handleAnular}
                        onChange={this._handleChangePagination}
                        onCierre={this.handleCerrar}
                        onImprimir={this.handleImprimir}
                    /> :
                    <ResultListSolicitud
                        pagination={this.state.paginationSolicitud}
                        loadingEdit={this.state.loadingSource}
                        loadingExcel={this.state.loadingExcel}
                        loadingPdf={this.state.loadingPdf}
                        loadingPrint={this.state.loadingPrint}
                        loadingImprimir={this.state.loadingImprimir}
                        onExportExcel={this.handleExportExcel}
                        onExportPdf={this.handleExportPdf}
                        onView={this.handleViewSolicitud}
                        onSustentar={this.handleViewSustento}
                        onChange={this._handleChangePagination}
                        onAprobar={this.handleAprobarSolicitud}
                        onAnular={this.handleAnularSolicitud}
                    />
                }


                <FormModal
                    visible={this.state.visible}
                    loadingChange={this.state.loadingChange}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onFilter={this.handleFilter}
                    onSave={this.handleSave}
                    onChange={this.handleChangeEstablecimiento}
                    onChangeAutocomplete={this.handleChangeAutocomplete}
                    onClearAutocomplete={this.handleClearAutocomplete}
                />

                <FormModalSolicitud
                    visible={this.state.visibleSolicitud}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visibleSolicitud: false })}
                    onSave={this.handleSaveSolicitud}
                    onChange={this.handleChangeSolicitudForm}

                />

                <FormModalSustento
                    visible={this.state.visibleSustento}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visibleSustento: false })}
                    onSave={this.handleSaveSustento}
                    onAgregarDetalle={this.handleAddDetalle}
                    onBuscarDocumentos={this.handleBuscarDocumentoSustento}


                />

                <FormModalCompra
                    visible={this.state.visibleCompra}
                    formValues={this.state.formValuesCompra}
                    onBuscarProveedor={this.handleBuscarProveedor}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onAgregarItem={this.handleAgregarItem}
                    onRemoverProducto={this.handleRemoverProducto}
                    onEditarNombreProducto={this.handleEditarNombreProducto}
                    onChange={this.handleChangeForm}
                    onClose={() => this.setState({ visibleCompra: false })}
                    onSave={this.handleSaveCompra}
                />

                <FormModalOtros
                    visible={this.state.visibleOtros}
                    formValues={this.state.formValuesCompra}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onAgregarItem={this.handleAgregarItem}
                    onRemoverProducto={this.handleRemoverProducto}
                    onEditarNombreProducto={this.handleEditarNombreProducto}
                    onChange={this.handleChangeOtrosForm}
                    onBuscarEntidad={this.handleBuscarEntidad}
                    onClose={() => this.setState({ visibleOtros: false })}
                    onSave={this.handleSaveDocumentoNoTributario}
                />

                <FormModalDevolucion
                    visible={this.state.visibleDevolucion}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visibleDevolucion: false })}
                    onSave={this.handleSaveDevolucion}
                    onSearch={this.handleOpenSearchSolicitud}
                    onChangeRow={this.handleSelectSolicitud}
                />

                <FormModalCierre
                    visible={this.state.visibleCierre}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visibleCierre: false })}
                    onSave={this.handleSaveArqueo}
                />


                <BuscarProductoModal
                    visible={this.state.searchProductVisible}
                    formValues={this.state.searchProductFormValues}
                    title={this.state.formValuesCompra.idTipo != 1 ? "Búsqueda de Producto" : "Búsqueda de Servicios"}
                    onChange={this.handleChangeProductoModal}
                    onSearch={this.handleChangeProductoModal}
                    onChangeRow={this.handleSelectProduct}
                    onCancel={() => this.setState({ searchProductVisible: false })}
                />

                <EditarNombreProductoModal
                    visible={this.state.editarNombreProductoVisible}
                    formValues={this.state.editarNombreProductoFormValues}
                    onClose={() => this.setState({ editarNombreProductoVisible: false })}
                    onSave={this.handleSaveEditarNombreProducto}
                />

                <ViewModal
                    visible={this.state.viewVisible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ viewVisible: false })}
                    onExportExcel={this.handleExportExcelView}
                    loadingExcel={this.state.loadingExcel}

                />
                <ViewModalSolicitud
                    visible={this.state.viewVisibleSolicitud}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ viewVisibleSolicitud: false })}
                />
                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onDownload={this.handleDownloadPdf}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />


            </div>
        )
    }

}